import { render, staticRenderFns } from "./mtAdmin.vue?vue&type=template&id=a6a035ee&"
import script from "./mtAdmin.vue?vue&type=script&lang=js&"
export * from "./mtAdmin.vue?vue&type=script&lang=js&"
import style0 from "./mtAdmin.vue?vue&type=style&index=0&id=a6a035ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports